// InputMobileModal.js
import React from "react";
import {
    Box,
    Button,
    IconButton,
    InputAdornment,
    Modal,
    TextField,
    Typography,
} from "@mui/material";
import { toast } from "react-toastify";

const InputMobileModal = ({
    isModalInputMobileOpen,
    handleCloseInputMobileModal,
    handleChange,
    error,
    helperText,
    mobileNo,
    InputProps,
}) => {

    return (
        <Modal open={isModalInputMobileOpen} onClose={handleCloseInputMobileModal}>
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    padding: 4,
                    backgroundColor: "#ffffff",
                    borderRadius: 2,
                    width: 400,
                    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
                }}
            >
                <Typography
                    variant="h6"
                    align="center"
                    sx={{ fontSize: "1.5rem", fontWeight: "600", color: "#333" }}
                >
                    Validate Mobile Number
                </Typography>
                <>
                    <Typography
                        variant="subtitle1"
                        style={{
                            fontWeight: 550,
                            color: "#29343d",
                            fontSize: "15px",
                            marginBottom: "5px",
                        }}
                    >
                        Mobile Number
                    </Typography>
                    <TextField
                        type="text"
                        variant="outlined"
                        placeholder="Enter your Number"
                        fullWidth
                        className="input_form"
                        value={mobileNo}
                        onChange={handleChange}
                        error={error}
                        helperText={helperText}
                        InputProps={InputProps}
                    />
                </>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: 2,
                    }}
                >
                    <Button
                        onClick={handleCloseInputMobileModal}
                        variant="outlined"
                        sx={{
                            flex: 1,
                            borderColor: "#3f51b5",
                            color: "#3f51b5",
                            "&:hover": { borderColor: "#303f9f", color: "#303f9f" },
                        }}
                    >
                        Back to Login
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default InputMobileModal;